module.exports = __webpack_public_path__ + "static/media/gup.c4770df8.svg";